import { Prop } from "vue-property-decorator";
import Vue from "vue";

/**
 *  Класс для компоненты кнопки назад
 */
export class BackLinkVue extends Vue {
  /**Текст кнопки*/
  @Prop() text!: string;

  /**Признак отключения действия кнопки(для кастомного клика)*/
  @Prop() noaction!: boolean;

  /** Признак подтверждения попытки вернуться назад */
  @Prop() confirmAction!: boolean;

  /** Текст окна подтверждения попытки вернуться назад */
  @Prop() confirmText!: string;

  /** Флаг окна подтверждения */
  showModal: boolean = false;

  /**Метод возвращения назад */
  back() {
    /** Если Признак подтверждения попытки вернуться назад есть, то показать окно */
    if (this.confirmAction) {
      this.showModal = true;
    } else if (!this.noaction) {
      this.$router.go(-1);
    }
  }
}
